import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";

const SubscriptionPolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button
          className="policy-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Subscription Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Overview</h2>
          <p>
            This Subscription Policy explains how Kairos plans, billing, renewals,
            upgrades/downgrades, cancellations, and usage-based charges work. If you
            need help, contact <strong>support@yourdomain.com</strong>.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Plans and features</h2>
          <ul>
            <li>
              Kairos offers subscription plans that may include limits (credits,
              pages, storage, bandwidth, team members, or features).
            </li>
            <li>
              Plan features may evolve over time as we improve the product.
            </li>
            <li>
              If you exceed plan limits, additional usage may be billed as overages
              (where enabled) or require an upgrade.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Billing cycle and renewals</h2>
          <ul>
            <li>
              Subscriptions renew automatically at the end of each billing period
              unless canceled before renewal.
            </li>
            <li>
              Billing periods may be monthly or annual depending on your selection.
            </li>
            <li>
              Charges are processed through our payment provider and may appear under
              a merchant descriptor related to Kairos or our payment partner.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Trials and promotional pricing</h2>
          <ul>
            <li>
              If a trial is offered, you will be charged at the end of the trial
              unless you cancel before the trial ends.
            </li>
            <li>
              Promotional pricing may apply for a limited time and may revert to
              standard pricing after the promotion ends.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Upgrades and downgrades</h2>
          <ul>
            <li>
              Upgrades may take effect immediately and may result in prorated charges
              depending on your billing settings.
            </li>
            <li>
              Downgrades may take effect at the end of the current billing period,
              and some features may become unavailable.
            </li>
            <li>
              If you downgrade, plan limits may apply to your account immediately or
              at the next cycle (depending on how the product is configured).
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Cancellation</h2>
          <ul>
            <li>
              You can cancel anytime from your account settings (or by contacting
              support if needed).
            </li>
            <li>
              After canceling, you keep access until the end of your current billing
              period (unless stated otherwise).
            </li>
            <li>
              Canceling stops future renewals but does not automatically refund past
              charges (see Refund Policy).
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>7. Credits and usage-based charges</h2>
          <ul>
            <li>
              Some plans include monthly credits. Credits may reset at the start of
              each billing cycle and may not roll over unless stated.
            </li>
            <li>
              If overages are enabled, additional usage may be billed once you exceed
              included credits/limits.
            </li>
            <li>
              We may enforce fair use protections and throttle or suspend abusive usage.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>8. Payment failures</h2>
          <ul>
            <li>
              If a payment fails, we may retry the charge and notify you to update
              your payment method.
            </li>
            <li>
              If payment issues remain unresolved, your account may be downgraded,
              paused, or limited until payment is successful.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>9. Account changes and termination</h2>
          <p>
            We may suspend or terminate accounts that violate our Terms & Conditions,
            misuse the platform, or engage in fraudulent activity. If we terminate for
            cause, refunds may not be provided.
          </p>
        </div>

        <div className="policy-section">
          <h2>10. Policy updates</h2>
          <p>
            We may update this Subscription Policy from time to time. Material changes
            will be communicated in reasonable ways, and the “Last updated” date will
            be revised.
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default SubscriptionPolicy;
